import React from "react";

function Decoration() {
  return (
    <div className="main__decoration">
      <div className="main__decoration__bable"></div>
      <div className="main__decoration__ligne"></div>
      <div className="main__decoration__ligne"> </div>
      <div className="main__decoration__ligne"> </div>
      <div className="main__decoration__ligne"> </div>
      <div className="main__decoration__ligne"> </div>
    </div>
  );
}

export default Decoration;
